import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import "../../AdminDashboard/Dashboard.css";
import CreateIcon from "@mui/icons-material/Create";
import "../../AdminDashboard/Vendor/VendorDetails.css";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import { Box, Chip } from "@mui/material";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Rating from "@mui/material/Rating";
import StarIcon from "@mui/icons-material/Star";
import Edit from "../../../icons/edit.svg";
import TableBody from "@mui/material/TableHead";
import { useTranslation } from "react-i18next";
import Evaluations from "./Evaluations";
import axios from "../../../utils/fvAxios";
import Nodata from "../../Nodata/Nodata";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { getOrgType } from "../../../utils/Token";
import GetfVDateFormate from "../../../utils/Genaricfunctions";


export default function ContractorEvaluations() {
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.action.hover,
    },

    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const [view, setView] = useState(true);
  const Viewed = () => {
    setView((view) => !view);
  };

  const [open, setOpen] = useState(true);

  const [GetSpecificEmployee, setGetSpecificEmployee] = React.useState([]);
  const [GetSpecificEvalution, setGetSpecificEvalution] = React.useState([]);
  const [error, setError] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [spinner, setSpinner] = React.useState(true);

  useEffect(() => {
    axios
      .get("AdminVendors/GetContractorEvaluations")

      .then((res) => {
        if (res?.data) {
          setGetSpecificEmployee(res?.data?.data);
        } else {
          setError(res.data.responseMessage);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setSpinner(false);
      });
  }, []);
  const OpenHandle = (r) => {
    setOpen((open) => !open);
    axios
      .get("AdminVendors/GetScoreCard?PreQualificationId=" + r?.prequalificationId + "&SelectedVendorId=" + r?.vendorId + "&VendorReviewInputId=" + r?.vendorReviewInputId + "&viewSource=0",

      )
      .then((res) => {
        if (res?.data) {
          setGetSpecificEvalution(res?.data?.data)


        } else {
          setError(res.data.responseMessage);

        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={spinner}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className="mt-3" hidden={GetSpecificEmployee?.length === 0}>

        {!open && <Evaluations data={GetSpecificEvalution} OPEN={OpenHandle} />}
        <TableContainer
          component={Paper}
          style={{ display: !open ? "none" : "block" }}
        >
          <h4 className="mx-3 my-3" variant="contained">
            {getOrgType() === "Client" ? "My Contractor Evaluations" : "Other Evaluations"}
          </h4>
          <Table aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell> Evaluated By</StyledTableCell>
                <StyledTableCell align="left"> Rating</StyledTableCell>
                <StyledTableCell align="left"> Review Date</StyledTableCell>
                <StyledTableCell align="left"> </StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {GetSpecificEmployee?.map((r, i) => (
                <TableRow
                  key={1}
                  sx={{
                    "&:last-child td": {
                      border: 0,
                    },
                    backgroundColor: "#fff",
                  }}
                >
                  <TableCell sx={{ width: "35%", color: "#2A93DB" }}>
                    <a
                      style={{ cursor: "pointer" }}
                      onClick={() => OpenHandle(r)}
                    >
                      {" "}
                      {r?.orgName}
                    </a>
                  </TableCell>
                  {/* {r.vendorReviewInputId} */}
                  <TableCell sx={{ width: "30%", backgroundColor: "#fff" }}>
                    <Box
                      sx={{
                        width: 200,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Box sx={{ mr: 2, color: "#2A93DB" }}>
                        {r?.userRating}
                      </Box>
                      <Rating
                        name="text-feedback"
                        value={r?.userRating}
                        readOnly
                        max={3}
                        precision={0.5}
                        sx={{ color: "#2A93DB" }}
                        emptyIcon={
                          <StarIcon
                            style={{ opacity: 0.55 }}
                            fontSize="inherit"
                          />
                        }
                      />
                    </Box>
                  </TableCell>
                  <TableCell sx={{ width: "32%" }}> {GetfVDateFormate(r?.reviewDate, "")}</TableCell>
                  <TableCell sx={{ width: "5%" }}>
                    <IconButton aria-label="edit"></IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

        </TableContainer>
      </div>
      <div hidden={spinner} style={{ display: GetSpecificEmployee?.length > 0 ? "none" : "" }}> <Nodata /></div>
    </div>
  );
}
